class GeoPoint {
  public readonly latitude: number;
  public readonly longitude: number;

  public constructor(latitude: number, longitude: number) {
    this.latitude = latitude;
    this.longitude = longitude;
  }
}

export default GeoPoint;
